import { render, staticRenderFns } from "./AddFormItem.vue?vue&type=template&id=0b95c8f4"
import script from "./AddFormItem.vue?vue&type=script&lang=js"
export * from "./AddFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports